import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from 'react-bootstrap/Navbar';
import axios from ".././axios-interceptor";
import { fundingClosedText, NOTIFICATION_TYPE_FUNDING_CLOSED_EARLY, NOTIFICATION_TYPE_LOAN_DISBURSED, base_url, NOTIFICATION_ENTITY_ALLINVESTORS, LOAN_CURRENCY_TYPE_USD, NOTIFICATION_ENTITY_INVESTOR, NOTIFICATION_TYPE_NEW_INVESTMENT_OPPORTUNITY, NOTIFICATION_TYPE_INTEREST_RECEIVED_FROM_INVESTOR, NOTIFICATION_TYPE_RENEW_DOCUMENT, socket_base_url, NOTIFICATION_TYPE_PAYMENT_PROCESSED, COMPLIANCE_APPROVED, NOTIFICATION_TYPE_KYC_APPROVED, NOTIFICATION_TYPE_KYC_REJECTED, NOTIFICATION_TYPE_LOAN_DELISTED, NOTIFICATION_TYPE_LOAN_TECHNICAL_CLOSURE, NOTIFICATION_TYPE_LOAN_CLOSED, NOTIFICATION_TYPE_WITHDRAWAL_APPROVED, NOTIFICATION_TYPE_WITHDRAWAL_REJECTED, NOTIFICATION_TYPE_FUNDING_80_PERCENT, NOTIFICATION_TYPE_OPPORTUNITY_FULLY_FUNDED, NOTIFICATION_TYPE_INVESTMENT_ADJUSTED } from "../utilities";
import Offcanvas from 'react-bootstrap/Offcanvas';
import { io } from 'socket.io-client';
import moment from "moment";
import { FaUserCircle } from "react-icons/fa";
import Cookies from 'js-cookie';
import { clearAllCookies } from "../clearCookies";

const InvestorNavBarMain = (props) => {

    let notifCount = props.count;
    const [wish, setWish] = useState('');
    const navigate = useNavigate();
    var today = new Date()
    var curHr = today.getHours()
    const [heading, setHeading] = useState('')
    const [msgBody, setMsgBody] = useState('')
    const [notifType, setNotifType] = useState()
    const [notifId, setNotifId] = useState()

    useEffect(() => {
        // const socket = window.location.hostname === "localhost" ? io('http://localhost:3051') :
        // io(window.location.protocol + "//" + window.location.hostname, {
        //   path: '/restsocket3051/',
        //   // autoConnect: false
        //   // transports: ["websocket"]
        // });
        const socket = window.location.hostname === "localhost" ? io('http://localhost:3000') :
            io(window.location.protocol + "//" + window.location.hostname, {
                path: '/restsocket3000/',
                // autoConnect: false
                // transports: ["websocket"]
            });
        socket.on(NOTIFICATION_ENTITY_ALLINVESTORS, notification => {
            let notifi = notification.data;

            if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_NEW_INVESTMENT_OPPORTUNITY) {
                setHeading('New Investment Opportunity!')
                setMsgBody(`Invest ${notifi.loan_currency === LOAN_CURRENCY_TYPE_USD ? "$\u00A0" + Number(notifi.loan_amount).toLocaleString() : 'BHD ' + Number(notifi.loan_amount).toLocaleString()} with tenure of ${notifi.loan_tenure === 1 ? notifi.loan_tenure + " Month" : notifi.loan_tenure + " Months "} in ${notifi.business_name} and get profit upto ${notifi.profit + "%"}`)
                setNotifType(notifi.notification_type)
                setNotifId(notifi.notification_id)
            }
            if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_LOAN_DELISTED) {
                setHeading('Loan Delisted')
                setMsgBody(`Your loan ${notifi.loan_reference_number} has been delisted by the admin`)
                setNotifType(notifi.notification_type)
                setNotifId(notifi.notification_id)
            }
            if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_LOAN_TECHNICAL_CLOSURE) {
                setHeading('Loan Technical Closure')
                setMsgBody(`Your loan ${notifi.reference_number} has been technical closed by the admin`)
                setNotifType(notifi.notification_type)
                setNotifId(notifi.notification_id)
            }

            setShowNotif(true);

        })
        socket.on(NOTIFICATION_ENTITY_INVESTOR, notification => {
            let notifi = notification?.data;
            if (!notifi) return;
            // The backend broadcasts every investor notification on the shared 'Investor' channel,
            // so only react to the ones addressed to the logged-in investor.
            const isMine = String(notifi.user_id) === String(Cookies.get("investor_id"));
            if (!isMine) return;

            const fundNowText = {
                [NOTIFICATION_TYPE_WITHDRAWAL_APPROVED]: {
                    heading: 'Withdrawal approved',
                    msgBody: `Your withdrawal request for ${notifi.reference_number} has been approved and the amount has been returned to your available balance.`,
                },
                [NOTIFICATION_TYPE_WITHDRAWAL_REJECTED]: {
                    heading: 'Withdrawal rejected',
                    msgBody: `Your withdrawal request for ${notifi.reference_number} has been rejected by the admin. The admin's note is shown in My Investments.`,
                },
                [NOTIFICATION_TYPE_FUNDING_80_PERCENT]: {
                    heading: 'Funding milestone reached',
                    msgBody: `${notifi.reference_number} has reached 80% of its funding target.`,
                },
                [NOTIFICATION_TYPE_OPPORTUNITY_FULLY_FUNDED]: {
                    heading: 'Opportunity fully funded',
                    msgBody: `${notifi.reference_number} is now fully funded and funding is closed.`,
                },
                [NOTIFICATION_TYPE_INVESTMENT_ADJUSTED]: {
                    heading: 'Investment adjusted by admin',
                    msgBody: `The admin has adjusted your investment in ${notifi.reference_number}. See My Investments for the updated amount.`,
                },
                [NOTIFICATION_TYPE_FUNDING_CLOSED_EARLY]: {
                    heading: 'Funding closed early',
                    msgBody: fundingClosedText(notifi),
                },
                [NOTIFICATION_TYPE_LOAN_DISBURSED]: {
                    heading: 'Loan disbursed',
                    msgBody: `Loan ${notifi.reference_number} has been disbursed to the business. Your returns are paid as it repays.`,
                },
                [NOTIFICATION_TYPE_LOAN_CLOSED]: {
                    heading: 'Loan closed',
                    msgBody: `Loan ${notifi.reference_number} has been fully repaid and closed.`,
                },
            }[parseInt(notifi.notification_type)];
            if (fundNowText) {
                setHeading(fundNowText.heading)
                setMsgBody(fundNowText.msgBody)
                setNotifType(notifi.notification_type)
                setNotifId(notifi.notification_id)
                setShowNotif(true);
                return;
            }
            if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_INTEREST_RECEIVED_FROM_INVESTOR) {

                if (notifi.user_id === Cookies.get("investor_id")) {
                    setHeading('Interest in this Investment Received!')
                    setMsgBody(`Your request has been received for ${notifi.reference_number} and Bennefin team will contact you to confirm the details`)
                    setNotifType(notifi.notification_type)
                    setNotifId(notifi.notification_id)
                    setShowNotif(true);
                }

            }
            if (
                parseInt(notifi.notification_type) ===
                NOTIFICATION_TYPE_KYC_APPROVED
            ) {
                setHeading("Investor KYC form has been approved");
                setMsgBody(
                    `KYC has been approved by the admin `
                );
                setNotifType(notifi.notification_type);
                setNotifId(notifi.notification_id);
            }
            if (
                parseInt(notifi.notification_type) ===
                NOTIFICATION_TYPE_KYC_REJECTED
            ) {
                setHeading("Investor KYC form has been rejected");
                setMsgBody(
                    `KYC has been rejected by the admin `
                );
                setNotifType(notifi.notification_type);
                setNotifId(notifi.notification_id);
            }
            if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_PAYMENT_PROCESSED) {
                if (notifi.user_id === Cookies.get("investor_id")) {
                    setHeading('Payment credited to your account!')
                    setMsgBody(`Bennefin transferred $\u00A0${notifi.paid_amount} on ${moment(Number(notifi.paid_date)).format("DD MMM YYYY")} to your account via ${notifi.received_via} for the loan, ${notifi.loan_reference_number}`)
                    setNotifType(notifi.notification_type)
                    setNotifId(notifi.notification_id)
                    setShowNotif(true);
                }

            }
            if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_RENEW_DOCUMENT) {
                if (notifi.status < new Date()) {
                    setHeading('KYC document expiry')
                    setMsgBody(`Renew your ${notifi.reference_number} document which is expired on ${moment(notifi.status).format("DD MMM YYYY")}`)
                    setNotifType(notifi.notification_type)
                    setNotifId(notifi.notification_id)
                } else {
                    setHeading('KYC document expiry')
                    setMsgBody(`Renew your ${notifi.reference_number} document which will expire on ${moment(notifi.status).format("DD MMM YYYY")}`)
                    setNotifType(notifi.notification_type)
                    setNotifId(notifi.notification_id)
                }
                setShowNotif(true);

            }

        })


        if (window.location.pathname === '/investordashboard') {
            setWish("Hi!")
        }

        return () => {
            socket.disconnect();
        };
    }, [curHr]);

    // const handleLogout = () => {
    //     axios.post(base_url + "user/logouttt", {
    //         "auth_refresh_token": Cookies.get('User_Refreshtoken_Investor')
    //     })
    //     // clearAllCookies();
    //     // navigate('/');
    // }

    const handleLogout = async (e) => {
        e.preventDefault(); 


        try {
            const token = Cookies.get('User_Refreshtoken_Investor');

            const response = await axios.post(base_url + "user/logout", {
                auth_refresh_token: token
            });


            clearAllCookies();
            navigate('/');

        } catch (error) {
            console.error("Error:", error.response?.data || error.message);
        }
    };
    let inv_name = props.investorname;


    const [showNotif, setShowNotif] = useState(false);
    const handleCloseNotif = () => setShowNotif(false);
    const handleShowNotif = () => setShowNotif(true);

    const handleViewDetails = () => {
        handleCloseNotif()
        let extend_url;
        if (parseInt(notifType) === NOTIFICATION_TYPE_NEW_INVESTMENT_OPPORTUNITY) {
            extend_url = 'notifications/update_is_read_investor_notification';
        } else {
            extend_url = 'notifications/update_is_read_notification'
        }
        axios
            .post(base_url + extend_url, {
                "notification_id": notifId,
                "investor_id": Cookies.get("investor_id")
            })
            .then((res) => {

                switch (parseInt(notifType)) {
                    case NOTIFICATION_TYPE_NEW_INVESTMENT_OPPORTUNITY:
                    case NOTIFICATION_TYPE_FUNDING_80_PERCENT:
                        if (window.location.pathname === '/investmentopportunities') {
                            setTimeout(() => {
                                window.location.reload()
                            }, 800);
                        } else {
                            navigate("/investmentopportunities")
                        }
                        break;
                    // case NOTIFICATION_TYPE_KYC_APPROVED:
                    //     case NOTIFICATION_TYPE_KYC_REJECTED:
                    //       if (window.location.pathname === "/investorsettings") {
                    //         setTimeout(() => {
                    //           window.location.reload();
                    //         }, 800);
                    //       } else {
                    //         navigate("/investorsettings");
                    //       }
                    //       break;

                    case NOTIFICATION_TYPE_KYC_APPROVED: {
                        const targetPath = "/investorKyc";

                        if (window.location.pathname === targetPath) {
                            setTimeout(() => {
                                window.location.reload();
                            }, 800);
                        } else {
                            navigate(targetPath);
                        }
                        break;
                    }

                    case NOTIFICATION_TYPE_KYC_REJECTED: {
                        const targetPath = "/investorsettings";

                        if (window.location.pathname === targetPath) {
                            setTimeout(() => {
                                window.location.reload();
                            }, 800);
                        } else {
                            navigate(targetPath);
                        }
                        break;
                    }

                    case NOTIFICATION_TYPE_PAYMENT_PROCESSED:
                    case NOTIFICATION_TYPE_WITHDRAWAL_APPROVED:
                    case NOTIFICATION_TYPE_WITHDRAWAL_REJECTED:
                    case NOTIFICATION_TYPE_OPPORTUNITY_FULLY_FUNDED:
                    case NOTIFICATION_TYPE_INVESTMENT_ADJUSTED:
                    case NOTIFICATION_TYPE_LOAN_CLOSED:
                    case NOTIFICATION_TYPE_LOAN_DISBURSED:
                    case NOTIFICATION_TYPE_FUNDING_CLOSED_EARLY:

                        if (window.location.pathname === '/myinvestments') {
                            setTimeout(() => {
                                window.location.reload()
                            }, 800);
                        } else {
                            navigate("/myinvestments")
                        }
                        break;
                    case NOTIFICATION_TYPE_INTEREST_RECEIVED_FROM_INVESTOR:
                        if (window.location.pathname === '/investornotifications') {
                            setTimeout(() => {
                                window.location.reload()
                            }, 800);
                        } else {
                            navigate("/investornotifications")
                        }
                        break;
                    case NOTIFICATION_TYPE_RENEW_DOCUMENT:
                        if (window.location.pathname === '/investorkycdocuments') {
                            setTimeout(() => {
                                window.location.reload()
                            }, 800);
                        } else {
                            navigate("/investorkycdocuments")
                        }
                        break;
                    default:
                        navigate("/investornotifications");
                        break;
                }
            })
    }

    return (

        <Navbar className="navbarTop" expand="lg">

            <div className="p-0 nav_first_child">

                {wish !== '' ? <Navbar.Brand href="" className="inv_db_navbar_brand ">
                    <div className="Inv_Styles">{wish !== '' ? wish + ' ' + inv_name : ''}</div>
                    <p>Welcome back, nice to see you again!</p>
                </Navbar.Brand> : ""}

                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse className="justify-content-end">
                    <Navbar.Text>
                        <div className="d-flex">
                            {Cookies.get("kyc_status") == COMPLIANCE_APPROVED && <div className="bell_styl" onClick={() => navigate('/investornotifications')}>
                                {notifCount === 0 ? <img src="./images/bellwithout.svg" alt="" /> : <img src="./images/bellwith_notif.svg" />}
                            </div>}
                            <div className="dropdown">
                                {Cookies.get("user_id") !== '' ?
                                    <div className="d-flex bell align-items-center gap-3">

                                        <div>


                                            <img className="dropbtn" src="./images/Ben_userProfile.svg" alt="true" />
                                        </div>
                                    </div> :
                                    <i className="fa-solid fa-user" />}
                                <div className="dropdown-content">
                                    {Cookies.get("kyc_status") == COMPLIANCE_APPROVED && <a href="/investorProfile">My     </a>}
                                    <a onClick={handleLogout} href="">Logout</a>
                                    {/* <button onClick={handleLogout}>Logout</button> */}
                                </div>
                            </div>

                        </div>
                    </Navbar.Text>
                </Navbar.Collapse>
            </div>


            {msgBody === '' ? '' : <Offcanvas placement='end' show={showNotif} onHide={handleCloseNotif} {...props} className='inv_notif'>

                <Offcanvas.Body className="p-3">
                    <div>

                        <div className="">
                            <div className="inv_notif_styl">
                                <div className="d-flex justify-content-between">
                                    <div >
                                        <h3 className="mb-0">{heading}</h3>
                                    </div>
                                    <img src="./images/Cancel.svg" alt="" className="Cpointer" onClick={handleCloseNotif} />
                                </div>
                                <p className="notif_msg_heigt">{msgBody}</p>
                                <div className="d-flex gap-3 mt-2">
                                    <span className="toast_viewdetails" onClick={handleViewDetails}>View Details</span>
                                    {/* <span className="toast_dismiss" onClick={handleCloseNotif}>Dismiss</span> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>}


        </Navbar>

    );
};

export default InvestorNavBarMain;

